import axios from 'axios';
import store from './store';
import router from './router';
import getEnv from '@/services/env';
import storageManager from '@/services/storageManager';
import { notifyError } from '@/services/notifications';
import { makeBasicAuthToken } from './services/auth';

const baseURL = getEnv('API_URL');
//const baseURL = 'http://192.168.1.231/api';
//const baseURL = 'https://localhost:44329/api';
const embURL = getEnv('EMB_URL');

// const serverDbURL = getEnv('SERVER_DB_URL');
// const serverAppURL = getEnv('SERVER_APP_URL');
// const axiosServicesDB = axios.create({ baseURL: serverDbURL});
// const axiosServicesAPP= axios.create({ baseURL: serverAppURL});
const services = getEnv('SERVICES');

const axiosBase = axios.create({ baseURL });
const axiosEmb = axios.create({ baseURL: embURL });
const axiosEmbDownload = axios.create({ baseURL: embURL });

const logout401Messages = ['WRONG_PASSWORD', 'WRONG_LOGIN'];

axiosBase.interceptors.request.use(setConfigFunction);

axiosEmb.interceptors.request.use(setConfigFunction);
axiosEmbDownload.interceptors.request.use(setConfigFunction);

function setConfigFunction(config) {
  const token = store.state.token;
  if (token) {
    config.headers.Authorization = token;
  } else {
    config.headers.Authorization = '';
  }

  return config;
}
function responseErrorCheck(error) {
  if (error.response && error.response.status === 401) {
    const { errorType } = error.response.data;

    if (errorType && logout401Messages.includes(errorType)) {
      notifyError('', 'Пожалуйста, авторизуйтесь снова');
      store.commit('logout');
      storageManager.removeItem('token');
      router.push({ path: '/login' });

      return Promise.reject(error);
    }
  }

  return Promise.reject(error);
}

axiosBase.interceptors.response.use((response) => {
  return response;
}, responseErrorCheck);

axiosEmb.interceptors.response.use((response) => {
  return response;
}, responseErrorCheck);

const login = {
  getIdentifier: (params) => {
    return axiosBase.get('/login', params);
  },
  getUserData: (params) => {
    return axiosBase.get('/login/user', params);
  },
  logOut: (params) => {
    return axiosBase.get('login/logout', params);
  },
  get: (params) => {
    return axiosBase.get('/login', params);
  },
  reLogin: (params) => {
    return axiosBase.get('/login', params);
  },
  reset: (data, params) => {
    return axiosBase.post('/tech/resetpassword', data, params);
  },
  changePassword: (data, params) => {
    return axiosBase.post('/tech/changepassword', data, params);
  },
  setHeader(params) {
    axiosBase.defaults.headers = params.headers;
  },
  setToken(token) {
    axiosBase.defaults.headers.common['Authorization'] = token;
  },
  clearHeader() {
    axiosBase.defaults.headers = null;
  },
};

const axiosAdmin = axios.create({ baseURL });
axiosAdmin.interceptors.request.use(setAdminConfigFunction);

function setAdminConfigFunction(config) {
  const password = store.state.adminPassword;
  config.headers.Authorization = makeBasicAuthToken('admin', password);

  return config;
}
const adminSettings = {
  adminAuth() {
    return axiosAdmin.get('/settings');
  },
  saveAdminSettings(data) {
    return axiosAdmin.post('/settings', data);
  },
  restart() {
    return axiosAdmin.get('/settings/restart');
  }
};

const loadingParams = {
  get() {
    return axiosBase.get('/settings/params');
  },
};

const banks = {
  get: (params) => axiosBase.get('/banks', { params }),
  getCount: (params) => axiosBase.get('/banks/count', { params }),
  getById: (bankId, params) => axiosBase.get(`/banks/${bankId}`, { params }),
  post: (data) => axiosBase.post('/banks', data),
  put: (bankId, data) => axiosBase.put(`/banks/${bankId}`, data),
  delete: (bankId, params) => axiosBase.delete(`/banks/${bankId}`, { params }),
  restore: (id, params) => axiosBase.get(`/banks/${id}/restore`, { params }),
};

const logs = {
  get: (params) => axiosBase.get('/logs', { params }),
  getById: (logId, params) => axiosBase.get(`/logs/${logId}`, { params }),
  getCount: (params) => axiosBase.get('/logs/count', { params }),
  types: {
    get: (params) => axiosBase.post('/logs/types', params),
  },
  getByCardId: (cardId, params) => {
    return axiosBase.get(`/cards/${cardId}/logs`, { params });
  },
  getPanByCardId: (cardId, params) => {
    return axiosBase.get(`/cards/${cardId}/pan`, { params });
  },
  getByDeviceId: (deviceId, params) => {
    return axiosBase.get(`/devices/${deviceId}/logs`, { params });
  },
};
const archiveCards = {
  get: (params) => {
    return axiosBase.get('/cardsArchive', { params });
  },
  getCount: (params) => {
    return axiosBase.get('/cardsArchive/count', { params });
  },
};
const cards = {
  get: (params) => {
    return axiosBase.get('/cards', { params });
  },
  getCount: (params) => {
    return axiosBase.get('/cards/count', { params });
  },
  move: (data, params) => {
    return axiosBase.post('/cards/move', data, { params });
  },
  loadParams: (data, params) => {
    return axiosBase.post('/cards/parameters', data, { params });
  },
  doCardAction: (actionPath, data, params) => {
    return axiosBase.post(`/cards${actionPath}`, data, { params });
  },
  changePriorities: (data, params) => {
    return axiosBase.put('/cards/changepriority', data, { params });
  },
  branches: (params) => axiosBase.get('/cards/branches', { params }),
};

const reports = {
  get: (paramsIn) => {
    return axiosBase.get('reports/cards', {
      params: paramsIn,
      responseType: 'arraybuffer',
    });
  },
};

const cardActions = {
  get: (data, params) => {
    return axiosBase.post('/cards/availablestatuses', data, { params });
  },
};

const kiosks = {
  get: (params) => {
    return axiosBase.get('/kiosks', { params });
  },
  post: (data) => axiosBase.post('/Kiosks', data),
  put: (deviceId, data) => axiosBase.put(`/Kiosks/${deviceId}`, data),
  delete: (deviceId, params) =>
    axiosBase.delete(`/Kiosks/${deviceId}`, { params }),
  changeKeyRTP: (kioskId, data) => {
    axiosBase.post(`kiosks/${kioskId}/changekey`, data);
  },
  getAvailableDevicesBr: (branchId, params) =>
    axiosBase.get(`/Kiosks/${branchId}/availableDevicesbr`, { params }),
  getAvailableDevices: (kioskID, params) =>
    axiosBase.get(`/Kiosks/${kioskID}/availableDevices`, { params }),

  restore: (deviceId, params) =>
    axiosBase.get(`/Kiosks/${deviceId}/restore`, { params }),
  changeDevice: (kioskId, data) =>
    axiosBase.post(`Kiosks/${kioskId}/changedevice`, data),

  checkLogs: (params) => {
    return axiosEmbDownload.get('/kiosks/check/logs', { params });
  },

  downloadLogsFile: (params) =>
    axiosEmbDownload.get('/kiosks/download/logs', {
      params,
      responseType: 'blob',
    }),
    
  checkMedia: (params) =>
    axiosEmbDownload.get('/kiosks/check/media', { params }),

  prepareMedia: (params, body) =>
    axiosEmbDownload.post(
      '/kiosks/prepare/media?' + new URLSearchParams(params),
      body
    ),

  getDownloadMediaUrl: (params) => {
    const base = (axiosEmbDownload.defaults.baseURL || '').replace(/\/$/, '');

    return `${base}/kiosks/download/media?${new URLSearchParams(params).toString()}`;
  },
};

const branches = {
  get: (params) => axiosBase.get('/branches', { params }),
  getCount: (params) => axiosBase.get('/branches/count', { params }),
  getById: (branchId, params) =>
    axiosBase.get(`/branches/${branchId}`, { params }),
  post: (data) => axiosBase.post('/branches', data),
  put: (branchId, data) => axiosBase.put(`/branches/${branchId}`, data),
  getByBanksId: (data) => axiosBase.post('/banks/branches', data),
  getByBanksArray: (data) => axiosBase.post('banks/branches', data),
  getByBanksArrayForCards: (data) =>
    axiosBase.post('/cards/banks/branches', data),
  getByBanksArrayForDevices: (data) =>
    axiosBase.post('/devices/banks/branches', data),
  getByBanksArrayForDevicesMonitor: (data) =>
    axiosBase.post('/devices/banks/branchesformonitor', data),

  getByBanksArrayForLogs: (data) =>
    axiosBase.post('/logs/banks/branches', data),

  delete: (branchId, params) =>
    axiosBase.delete(`branches/${branchId}`, { params }),
  getFromBank: (bankId, params) =>
    axiosBase.get(`/banks/${bankId}/branches`, { params }),
  unpin: (data) => axiosBase.post('/branches/unpin', data),
  pin: (branchId, data) => axiosBase.post(`/branches/${branchId}/pin`, data),
  getAvailableBranchesToPin: (branchId, params) =>
    axiosBase.get(`/branches/${branchId}/availabletopinbranches`, { params }),

  getByBanksArrayForUsersPage: (data) =>
    axiosBase.post('/users/banks/branches/0', data),
  getByBanksArrayForUsersCreate: (data) =>
    axiosBase.post('/users/banks/branches/1', data),
  getByBanksArrayForUsersEdit: (data) =>
    axiosBase.post('/users/banks/branches/2', data),

  restore: (id, params) => axiosBase.get(`/branches/${id}/restore`, { params }),
};

const cardStatuses = {
  get: (params) => axiosBase.get('/cardstatuses', { params }),
  getArchive: (params) => axiosBase.get('/cardstatuses/archive', { params }),
};

const cardPriorities = {
  get: (params) => axiosBase.get('/cardpriorities', { params }),
};

const products = {
  get: (params) => axiosBase.get('/products', { params }),
  getCount: (params) => axiosBase.get('/products/count', { params }),
  getFromDevice: (deviceId, params) =>
    axiosBase.get(`/devices/${deviceId}/products`, { params }),
  getAvailableForDevice: (deviceId, params) =>
    axiosBase.get(`/devices/${deviceId}/availableProducts`, { params }),
  attachProductsToDevice: (deviceId, data) =>
    axiosBase.post(`/devices/${deviceId}/attachProducts`, data),
  unpinFromDevice: (deviceId, params) =>
    axiosBase.get(`/devices/${deviceId}/unpinProduct`, { params }),
  getById: (productId, params) =>
    axiosBase.get(`/products/${productId}`, { params }),
  post: (data) => axiosBase.post('/products', data),
  put: (productId, data) => axiosBase.put(`/products/${productId}`, data),
  delete: (productId, params) =>
    axiosBase.delete(`/products/${productId}`, { params }),
  getByBanksId: (data) => axiosBase.post('/banks/products', data),
  getByBanksArray: (data) => axiosBase.post('banks/products', data),
  getByBanksArrayForDevices: (data) =>
    axiosBase.post('devices/banks/products', data),
  getByBanksArrayForCards: (data) =>
    axiosBase.post('cards/banks/products', data),
  getByBanksArrayForLogs: (data) => axiosBase.post('logs/banks/products', data),
  getByDeviceAndHopperNumber: (deviceId, hopperNumber, params) =>
    axiosBase.get(`devices/${deviceId}/hoppers/${hopperNumber}/products`, {
      params,
    }),
  getStatuses: () => axiosBase.get('/products/statuses'),
  restore: (id, params) => axiosBase.get(`/products/${id}/restore`, { params }),
};

const jobs = {
  get: (params) => axiosBase.get('/jobs', { params }),
  getByBanksArrayForCards: (data) => axiosBase.post('cards/banks/jobs', data),
};

const devices = {
  get: (params) => axiosBase.get('/devices', { params }),
  getLastSync: (params) => axiosBase.get('/devices/lastSync', { params }),
  getPaginated: (params) => axiosBase.get('/devices/paginated', { params }),
  getCount: (params) => axiosBase.get('/devices/count', { params }),
  getCountCustom: (params) => axiosBase.get('/devices/countcustom', { params }),
  getById: (deviceId, params) =>
    axiosBase.get(`/devices/${deviceId}`, { params }),
  getFromBranch: (branchId, params) =>
    axiosBase.get(`/branches/${branchId}/devices`, { params }),
  post: (data) => axiosBase.post('/devices', data),
  put: (deviceId, data) => axiosBase.put(`/devices/${deviceId}`, data),
  delete: (deviceId, params) =>
    axiosBase.delete(`/devices/${deviceId}`, { params }),
  getByBanksId: (data) => axiosBase.post('/banks/branches', data),
  getByBanksArray: (data) => axiosBase.post('banks/devices', data),
  getByBanksArrayForCards: (data) =>
    axiosBase.post('cards/banks/devices', data),
  getByBanksArrayForLogs: (data) => axiosBase.post('logs/banks/devices', data),
  getByBranchesArray: (data) => axiosBase.post('branches/devices', data),
  getByBranchesArrayForCards: (data) =>
    axiosBase.post('cards/branches/devices', data),
  getByBranchesArrayForLogs: (data) =>
    axiosBase.post('logs/branches/devices', data),
  changeBranch: (deviceId, data) =>
    axiosBase.post(`devices/${deviceId}/changebranch`, data),
  restore: (deviceId, params) =>
    axiosBase.get(`/devices/${deviceId}/restore`, { params }),
};

const hoppers = {
  getCountCards: (deviceId, hopperNumber, params) =>
    axiosBase.get(`devices/${deviceId}/hoppers/${hopperNumber}/count`, {
      params,
    }),

  changeCards: (deviceId, hopperNumber, par, count, params) =>
    axiosBase.post(
      `devices/${deviceId}/${hopperNumber}/changecards/${par}/${count}`,
      {
        params,
      }
    ),
};

const deviceTypes = {
  get: (params) => axiosBase.get('/deviceTypes', { params }),
};

const statusTypes = {
  get: (params) => axiosBase.get('/DeviceStatusTypes', { params }),
};

const roles = {
  get: (params) => axiosBase.get('/roles', { params }),
  getById: (roleId, params) => axiosBase.get(`/roles/${roleId}`, { params }),
  put: (roleId, data) => axiosBase.put(`/roles/${roleId}`, data),
  delete: (roleId, params) => axiosBase.delete(`/roles/${roleId}`, { params }),
  post: (data) => axiosBase.post('/roles', data),
};

const rights = {
  get: (params) => axiosBase.get('/rights', { params }),
  getByRoleId: (roleId, params) =>
    axiosBase.get(`/roles/${roleId}/rights`, { params }),
  setRightsForRoleId: (roleId, data) =>
    axiosBase.post(`/roles/${roleId}/rights`, data),
  getRightsByRolesArrayWithUserId: (userId, data) =>
    axiosBase.post(`users/${userId}/roles/rights`, data),
};

const users = {
  get: (params) => axiosBase.get('/users', { params }),
  getCount: (params) => axiosBase.get('/users/count', { params }),
  getById: (userId, params) => axiosBase.get(`/users/${userId}`, { params }),
  deleteById: (userId, params) =>
    axiosBase.delete(`/users/${userId}`, { params }),
  post: (data) => axiosBase.post('/users', data),
  putById: (userId, data) => axiosBase.put(`/users/${userId}`, data),
  putByIdTimeout: (userId, data) =>
    axiosBase.put(`/users/timeout/${userId}`, data),
  lock: (userId, params) => axiosBase.get(`/users/${userId}/block`, { params }),
  unlock: (userId, params) =>
    axiosBase.get(`/users/${userId}/unblock`, { params }),
  setRolesAndRights: (userId, data) =>
    axiosBase.post(`users/${userId}/setrolesandrights`, data),
  changeBranch: (userId, data) =>
    axiosBase.post(`users/${userId}/changebranch`, data),
  restore: (id, params) => axiosBase.get(`/users/${id}/restore`, { params }),
};

const userTypes = {
  get: (params) => axiosBase.get('/users/usertypes', { params }),
};

const langs = {
  getList: (params) => axiosBase.get('/tech/langList', { params }),
  getLang: (params) => axiosBase.get('/tech/lang', { params }),
};

const embRequests = {
  getTest: (params) => axiosEmb.get('/kiosks/testconnection', { params }),
  postTest: (data) => axiosEmb.post('/kiosks/testconnection', data),
  toggleSuspended: (params) => axiosEmb('/kiosks/togglesuspended', { params }),
  restartApplication: (params) => axiosEmb.get('/kiosks/restartapplication', { params }),
  restartPc: (params) => axiosEmb.get('/kiosks/restartpc', { params }),
};

const techAdress = {
  get: (params) => {
    return axiosBase.get('/tech/techadress', { params });
  },
};

const servicesApi = {
  getStatus: (service) => {
    return axios.get(`/${service}`, { baseURL: services[service] });
  },
  restart: (service) => {
    return axios.put(`/${service}`, {}, { baseURL: services[service] });
  }
};

function setEmbBaseUrl(url) {
  if (url) {
    axiosEmb.defaults.baseURL = url;
    axiosEmbDownload.defaults.baseURL = url;
  }
}

export default {
  setEmbBaseUrl,
  login,
  banks,
  cards,
  archiveCards,
  cardActions,
  kiosks,
  branches,
  cardStatuses,
  cardPriorities,
  products,
  jobs,
  devices,
  roles,
  rights,
  users,
  deviceTypes,
  userTypes,
  statusTypes,
  logs,
  langs,
  reports,
  hoppers,
  embRequests,
  techAdress,
  adminSettings,
  loadingParams,
  // axiosServicesDB,
  // axiosServicesAPP,
  servicesApi,
};
